import { NormalizedNumber } from '@sparkdotfi/common-universal'
import { z } from 'zod'

import { SwapFormSchema } from './schema'
import { TokenRepository } from '@/domain/token-repository/TokenRepository'
import { TokenSymbol } from '@/domain/types/TokenSymbol'
import {
  ValidateTransferFromUserParams,
  validateTransferFromUser,
} from '@/features/dialogs/common/logic/transfer-from-user/validation'

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getSwapFormValidator(tokenRepository: TokenRepository) {
  return SwapFormSchema.superRefine((field, ctx) => {
    const amount = NormalizedNumber(field.amount === '' ? '0' : field.amount)
    const balance = tokenRepository.findOneBalanceOrZero(TokenSymbol(field.from))

    const issue = validateTransferFromUser({
      value: amount,
      user: { balance },
    })
    if (issue) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: swapValidationIssueToMessage[issue],
        path: ['amount'],
      })
    }
  })
}

export interface ValidateSwapWithPsm3Args extends ValidateTransferFromUserParams {
  isSwapToUsdc: boolean
  psm3: {
    usdsBalance: NormalizedNumber
    usdcBalance: NormalizedNumber
  }
}
export function validateSwapWithPsm3({
  value,
  isSwapToUsdc,
  user: { balance },
  psm3: { usdsBalance, usdcBalance },
}: ValidateSwapWithPsm3Args): ValidateSwap | undefined {
  if (isSwapToUsdc) {
    if (usdcBalance.lt(value)) {
      return 'usdc-withdraw-cap-reached'
    }
  } else {
    if (usdsBalance.lt(value)) {
      return 'usds-withdraw-cap-reached'
    }
  }

  return validateTransferFromUser({
    value,
    user: { balance },
  })
}

export type ValidateSwap =
  | 'exceeds-balance'
  | 'value-not-positive'
  | 'usds-withdraw-cap-reached'
  | 'usdc-withdraw-cap-reached'

export const swapValidationIssueToMessage: Record<ValidateSwap, string> = {
  'value-not-positive': 'Amount should be positive',
  'exceeds-balance': 'Exceeds your balance',
  'usds-withdraw-cap-reached': 'USDS withdraw cap temporarily reached',
  'usdc-withdraw-cap-reached': 'USDC withdraw cap temporarily reached',
}
